import { useModal } from '@trinity/chat-components/components/Modal/index.js';
import { DeleteFilePrompt } from './Prompt.DeleteFile';

export const useDeleteFilePrompt = () => {
  return useModal(DeleteFilePrompt);
};